import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthGuardService} from './auth/authguard.service';
import {WarrantyComponent} from './components/warranty/warranty-steps/warranty.component';
import {WarrantyListComponent} from './components/warranty-list/warranty-list.component';
import {AdminPromotionsComponent} from './components/admin/promotion-config/promotions/admin-promotions.component';
import {BlacklistComponent} from './components/admin/blacklist/blacklist.component';
import {WarrantyConfigComponent} from './components/admin/warranty-config/warranty-config.component';
import {DealerListComponent} from './components/admin/dealer-list/dealer-list.component';
import {DisclaimerConfigComponent} from './components/admin/disclaimer-config/disclaimer-config.component';
import {HelpConfigComponent} from './components/admin/help-config/help-config.component';
import {LoginComponent} from './components/commons/login/login.component';
import {PromotionsComponent} from './components/promotions/promotions.component';
import {PromotionComponent} from './components/admin/promotion-config/promotion/promotion.component';
import {HelpComponent} from './components/commons/help/help.component';
import {LogoutComponent} from './components/commons/logout/logout.component';
import {EamComponent} from './components/commons/eam/eam.component';
import {CalcLogComponent} from './components/admin/calc-log/calc-log.component';
import {AdminWarrantyListComponent} from './components/admin/admin-warranty-list/admin-warranty-list.component';
import {E4nUploadComponent} from './components/admin/e4n-upload/e4n-upload.component';
import {SupportComponent} from './components/support/support.component';
import {ActionPeriodListComponent} from './components/admin/action-periods/action-period-list/action-period-list.component';
import {ActionPeriodComponent} from './components/admin/action-periods/action-period/action-period.component';
import {ReportComponent} from './components/reports/report/report.component';
import {environment} from '../environments/environment';
import {EstimationComponent} from './estimation/estimation.component';
import {MessagesComponent} from './components/messages/messages.component';
import { DealerCorrectionReviewComponent } from './dealer-correction-review/dealer-correction-review.component';
import { AdminWarrantyConditionsComponent } from './components/admin/admin-warranty-conditions-upload/admin-warranty-conditions.component';
import {
  UploadWarrantyContractsComponent
} from './components/warranty-list/upload-warranty-contracts/upload-warranty-contracts/upload-warranty-contracts.component';

const routes: Routes = [
  {path: '', component: LoginComponent},
  {path: 'login', component: LoginComponent},
  {path: 'eam', component: EamComponent},
  {path: 'dashboard', component: WarrantyListComponent, canActivate: [AuthGuardService]},
  {path: 'warranty/:id', component: WarrantyComponent, canActivate: [AuthGuardService]},
  {path: 'warranty', component: WarrantyComponent, canActivate: [AuthGuardService]},
  {path: 'estimations', component: EstimationComponent, canActivate: [AuthGuardService]},
  {path: 'promotions', component: PromotionsComponent, canActivate: [AuthGuardService]},
  {path: 'support', component: SupportComponent, canActivate: [AuthGuardService]},
  {path: 'report', component: ReportComponent, canActivate: [AuthGuardService]},
  {path: 'help', component: HelpComponent, canActivate: [AuthGuardService]},
  {path: 'logout', component: LogoutComponent, canActivate: [AuthGuardService]},
  {path: 'admin/promotions', component: AdminPromotionsComponent, canActivate: [AuthGuardService]},
  {path: 'admin/action-periods', component: ActionPeriodListComponent, canActivate: [AuthGuardService]},
  {path: 'admin/action-period', component: ActionPeriodComponent, canActivate: [AuthGuardService]},
  {path: 'admin/action-period/:id', component: ActionPeriodComponent, canActivate: [AuthGuardService]},
  {path: 'admin/warranties', component: AdminWarrantyListComponent, canActivate: [AuthGuardService]},
  {path: 'admin/promotion', component: PromotionComponent, canActivate: [AuthGuardService]},
  {path: 'admin/promotion/:id', component: PromotionComponent, canActivate: [AuthGuardService]},
  {path: 'admin/calc-log', component: CalcLogComponent, canActivate: [AuthGuardService]},
  {path: 'admin/blacklist', component: BlacklistComponent, canActivate: [AuthGuardService]},
  {path: 'admin/config', component: WarrantyConfigComponent, canActivate: [AuthGuardService]},
  {path: 'admin/dealers', component: DealerListComponent, canActivate: [AuthGuardService]},
  {path: 'admin/disclaimer', component: DisclaimerConfigComponent, canActivate: [AuthGuardService]},
  {path: 'admin/help-config', component: HelpConfigComponent, canActivate: [AuthGuardService]},
  {path: 'admin/e4n', component: E4nUploadComponent, canActivate: [AuthGuardService]},
  {path: 'messages', component: MessagesComponent, canActivate: [AuthGuardService]},
  {path: 'dealer-correction-review', component: DealerCorrectionReviewComponent, canActivate: [AuthGuardService]},
  {path: 'booklets/list-warranty-conditions-structure', component: AdminWarrantyConditionsComponent, canActivate: [AuthGuardService]},
  {path: 'upload', component: UploadWarrantyContractsComponent, canActivate: [AuthGuardService]},
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: environment.useHashBang})],
  exports: [RouterModule]
})

export class AppRoutingModule {
}
